import megatron from '@ibibo/megatron';

export function prepareThankYouUrl({paymentid}) {
  return `${__ENV_CONFIG__.MYPARTNER}/api/v1/hotels/booking_status?paymentid=${paymentid}`;
}

const hotelsThankYouApi = async (params) => {
  const url = prepareThankYouUrl(params);
  const response = await megatron({
    name: 'desc block api',
    type: 'GET',
    url,
    credentials: 'include',
    headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
  });
  return response;
};

export {
  hotelsThankYouApi
};
